module.exports = __webpack_public_path__ + "static/media/fontello.926c111f.eot";